<template>
  <div>
    <h5>Подтверждение компанией</h5>
    <br />
    <div class="install-control">
      <button v-if="$store.state['user']['is_root'] && contract" @click="cancel"
        class="btn btn-danger">{{ 'cancel_order' | setText('Отменить заказ') }}</button>
      <button @click="next" class="btn btn-success">{{ 'next_step' | setText('Далее') }}</button>
    </div>
  </div>
</template>
<script>
import { logger } from '../../../plugins/functions';

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0
    },
    createTransaction: {
      default: function () {
      },
    },
    contract: {
      default: null
    }
  },
  name: "filter",
  async created() {

  },
  methods: {
    cancel() {
      this.$loading(true);

      logger(this.$http, {
        name: 'Отмена заказа в #PAYMART',
        description: 'Начало запроса',
        model_type: 'order',
        model_id: this.order.id,
      });

      this.$http
        .post(`${this.partner['endpoint_url']}buyers/credit/cancel`,
          {
            buyer_phone: this.order.client.phone,
            contract_id: this.contract,
          },
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {
          if (response.data) {
            switch (response.data.result.status) {
              case 1:
                this.message = 'Успешно отменен';
                this.createTransaction({
                  status: -1,
                });
                this.$emit('next', -1);
                break;
              default:
                this.message = 'Заказ не отменен';
                break;
            }

            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
            logger(this.$http, {
              name: 'Отмена заказа в #PAYMART',
              description: this.message,
              model_type: 'order',
              model_id: this.order.id,
            });
          }

        })
        .catch((error) => {

          logger(this.$http, {
            name: 'Отмена заказа в #PAYMART',
            description: 'Ошибка системы #PAYMART',
            model_type: 'order',
            model_id: this.order.id,
          });
          alert('Ошибка партнера');

        })
        .finally(() => {
          this.$loading(false);
        });
    },
    next() {
      this.save();
    },
    prev() {
      this.$emit('next', this.index - 1);
    },
    save() {
      this.$loading(true);

      logger(this.$http, {
        name: 'Подтверждение заказа (компания) в #PAYMART',
        description: 'Начало запроса',
        model_type: 'order',
        model_id: this.order.id,
      });

      this.$http
        .post(`${this.partner['endpoint_url']}buyers/partner-confirm`,
          {
            contract_id: this.contract,
          },
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {
          if (response.data) {
            switch (response.data.result.status) {
              case 1:
                this.message = 'Подтверждено';
                //temp
                this.$emit('next', 11);
                this.createTransaction({
                  system_confirmed: 1,
                });
                break;
              case 0:
                this.message = 'Не подтверждено';
                break;
              default:
                this.message = 'Неизвестная ошибка';
                break;
            }

            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
            logger(this.$http, {
              name: 'Подтверждение заказа (компания) в #PAYMART',
              description: this.message,
              model_type: 'order',
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: 'Подтверждение заказа (компания) в #PAYMART',
            description: 'Ошибка системы #PAYMART',
            model_type: 'order',
            model_id: this.order.id,
          });
          alert('Ошибка партнера');
        })
        .finally(() => {

          this.$loading(false);


        });
    },
  },
  data() {
    return {
      code: null,
      message: ''
    };
  },
};
</script>
<style lang="scss">

</style>
